import { Route, Routes } from "react-router-dom";
import "./index.css";
import UsesPage from "./pages/Uses";
import HomePage from "./pages/Homepage";
import NavBar from "./components/Nav";

export function App() {
  return (
    <div>
      <div>

      {/* <Nav /> */}
      <NavBar/>
      </div>
      <div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/uses" element={<UsesPage />} /> */}
      </Routes>

      </div>
    </div>
  );
}

export default App;
